// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Countdown_countdown__X_TcY","timePart":"Countdown_timePart__MAfM6","hidden":"Countdown_hidden__WiMHF"};